export default __webpack_public_path__ + "static/media/biofit-builder-series-RX-DC.70d46032.png";